import Layout from '@layout/index';
import { SWRConfig } from 'swr';
import setupInitialProps from '@utils/setupInitialProps';
import PrimeHome from '@cont/PrimeHome/PrimeHome';
import {
  PrimePageProps,
  primeGetInitialProps
} from '@cont/PrimeHome/prime.helpers';

const PrimePage = ({
  specialClasses,
  subCategories,
  liveNow,
  sheldon,
  fallback
}: PrimePageProps) => {
  return (
    <SWRConfig
      value={{
        revalidateOnMount: false,
        dedupingInterval: 60 * 1000,
        fallback
      }}
    >
      <PrimeHome
        specialClasses={specialClasses}
        subCategories={subCategories}
        liveNow={liveNow}
        sheldon={sheldon}
      />
    </SWRConfig>
  );
};

PrimePage.Layout = Layout;

PrimePage.pageInfo = {
  isMWebSupported: true,
  name: 'Prime',
  layoutOptions: {
    showPlusNav: true,
    hideFooter: true,
    hideIntercom: true,
    primeTheme: true,
    fullHeightContent: true
  }
};

export default PrimePage;

PrimePage.getInitialProps = (setupInitialProps as any)(
  primeGetInitialProps,
  PrimePage.pageInfo
);
